/* eslint-disable react/jsx-props-no-spreading */
import type {
  CreatorFilter,
  Sort,
  TypeFilter,
  WorkspaceFilter,
} from '@carboncopyco/types';
import {
  CapsuleDropdown,
  type CapsuleDropdownContentProps,
  Flex,
  Spacer,
} from '@carboncopyco/ui';

interface SearchControlsProps {
  creatorFilterDropdown: CapsuleDropdownContentProps<CreatorFilter>;
  typeFilterDropdown?: CapsuleDropdownContentProps<TypeFilter>;
  workspaceFilterDropdown?: CapsuleDropdownContentProps<WorkspaceFilter>;
  sortDropdown: CapsuleDropdownContentProps<Sort>;
}

export const SearchControls = ({
  creatorFilterDropdown,
  typeFilterDropdown,
  workspaceFilterDropdown,
  sortDropdown,
}: SearchControlsProps) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
    >
      <Flex alignItems="center">
        <CapsuleDropdown {...creatorFilterDropdown} />
        <Spacer />
        {typeFilterDropdown && (
          <>
            <CapsuleDropdown {...typeFilterDropdown} />
            <Spacer />
          </>
        )}
        {workspaceFilterDropdown && (
          <>
            <CapsuleDropdown
              {...workspaceFilterDropdown}
              scroll
              ellipsis
            />
            <Spacer />
          </>
        )}
        <CapsuleDropdown {...sortDropdown} />
      </Flex>
    </Flex>
  );
};
